import { Tooltip } from '@bay-email/editor';
import { classnames } from '@extensions/utils/classnames';
import React from 'react';

type ToolItemProps = {
	title?: string;
	icon: React.ReactNode;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
	trigger?: string;
	style?: React.CSSProperties;
	isActive?: boolean;
};

export const ToolItem = React.forwardRef<HTMLButtonElement, ToolItemProps>(
	(props, ref) => {
		// Prevent mousedown from causing the editor to lose focus/selection
		const handleMouseDown = (e: React.MouseEvent) => {
			e.preventDefault();
		};

		if (!props.title) {
			return (
				<button
					ref={ref}
					tabIndex={-1}
					className='bay-email-extensions-emailToolItem'
					title={props.title}
					onClick={props.onClick}
					onMouseDown={handleMouseDown}
					style={props.style}
				>
					{props.icon}
				</button>
			);
		}
		return (
			<Tooltip
				content={props.title}
				placement='top'
			>
				<button
					ref={ref}
					tabIndex={-1}
					className={classnames(
						'bay-email-extensions-emailToolItem',
						props.isActive && 'bay-email-extensions-emailToolItem-active',
					)}
					onClick={props.onClick}
					onMouseDown={handleMouseDown}
					style={props.style}
				>
					{props.icon}
				</button>
			</Tooltip>
		);
	},
);

ToolItem.displayName = 'ToolItem';
